import axios from '../http';
import {DELETE_AWS_SES_SUPPRESSED_DESTINATION} from '../../../paths';
export async function deleteSuppressedDestination(emailAddress: string): Promise<void> {
    const result = await axios.delete(`api/email/${DELETE_AWS_SES_SUPPRESSED_DESTINATION}/${encodeURIComponent(emailAddress.trim())}`);
    return result.data;
}
